import { displayDate, type SupportedLocale } from "./displayDate";

const osloCalendarDay = (iso: string): string =>
  new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Oslo", year: "numeric", month: "2-digit", day: "2-digit" }).format(
    new Date(iso),
  );

export const displayOsloDate = (iso: string, locale?: SupportedLocale | null): string =>
  displayDate(osloCalendarDay(iso), locale);
